import Cookies from 'js-cookie'

const TokenKey = 'token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

const languageKey = 'languageKey'

export function getLKey() {
  return 'zh'
  // return Cookies.get(languageKey) || 'zh'
}

export function setLKey(token) {
  return Cookies.set(languageKey, token)
}

export function removeLKey() {
  return Cookies.remove(languageKey)
}

const accountKey = 'accountKey'

export function getAccountKey() {
  return Cookies.get(accountKey)
}

export function setAccountKey(string) {
  return Cookies.set(accountKey, string)
}

export function removeAccountKey() {
  return Cookies.remove(accountKey)
}

const pageKey = 'pageKey'

export function getPageKey(key) {
  let pageData = Cookies.get(pageKey)
  pageData = pageData ? JSON.parse(pageData) : {}
  return pageData[key]
}

export function setPageKey(key, value) {
  let pageData = Cookies.get(pageKey)
  pageData = pageData ? JSON.parse(pageData) : {}
  pageData[key] = value
  return Cookies.set(pageKey, JSON.stringify(pageData))
}

export function removePageKey(key) {
  let pageData = Cookies.get(pageKey)
  pageData = pageData ? JSON.parse(pageData) : {}
  delete pageData[key]
  Cookies.set(pageKey, JSON.stringify(pageData))
  return true
}
